/*
 * This file is part of the Det Norske Teatret Nettside 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React, { type ComponentType } from 'react';
import Actors from 'components/Ensemble/Actors/Actors';
import Artistic from 'components/Ensemble/Artistic/Artistic';
import Band from 'components/Ensemble/Band/Band';
import Contributors from 'components/Ensemble/Contributors/Contributors';

import 'components/Ensemble/Ensemble.scss';

const content = {
  actors: Actors,
  artisticStab: Artistic,
  band: Band,
  contributors: Contributors,
};

type EnsembleType = 'actors' | 'artisticStab' | 'band' | 'contributors';

interface EnsembleProps {
  type?: EnsembleType;
  title?: string | null;
  // The rest goes to the block; its shape depends on `type` and comes from Twig.
  [prop: string]: unknown;
}

/**
 * This is the Ensemble component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function Ensemble({ type = 'actors', title = null, ...props }: EnsembleProps) {
  const Block = (content[type] ?? null) as ComponentType<
    Record<string, unknown>
  > | null;
  if (!Block) return null;

  function renderTitle() {
    if (!title) return null;
    return <h2>{title}</h2>;
  }

  return (
    <div className="block block-ensemble">
      {renderTitle()}
      <Block type={type} level={title ? 3 : 2} {...props} />
    </div>
  );
}

export default Ensemble;
